export async function presentationDownloader(res, fileName) {
  const blobSource = await res?.blob();
  const url = window.URL.createObjectURL(
    new Blob([blobSource], {
      type: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    })
  );
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `${fileName}.pptx`);
  link.click();
}
